import "./tableBox.scss";
export default function TableBox({
  TableInfo = [["header1", "data1"]],
  Status,
}: {
  TableInfo: [string, any][];
  Status: boolean;
}): JSX.Element {
  return (
    <div
      className={`d-flex flex-row flex-wrap rounded-3 tableBox ${
        !Status && "bg-secondary"
      } `}
      style={{
        width: "100%",
        background: "#668CD9",
        color: "white",
        // overflow: "hidden",
      }}
    >
      {TableInfo.map((item) => (
        <div className="d-flex flex-column border-end border-bottom items flex-fill">
          <div className=" border-bottom p-3">
            <div className="mx-auto" style={{ width: "fit-content" }}>
              {item[0]}
            </div>
          </div>
          <div className="p-3 my-auto">
            <div className="mx-auto text-center">{item[1]}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
